import Cookies from '/node_modules/js-cookie/src/js.cookie.js';

class AlertPuntiEstateComponent {
	constructor() {
		this.showMessage = null;
		this.oneDayValidity = 86400000;
		this.init();
	}

	appendAlert() {
		let alertHtml = `
		<div class="alert-punti-estate-wrapper">
			<div class="alert-close">
				<svg><use xlink:href="#svg_circle_close"></use></svg>
			</div>
			<div class="text-wrapper">
				<div class="alert-title">Avviso sospensione servizio</div>
				<div class="alert-message">
					Le spedizioni dei premi saranno <strong>sospese dal 22/07 al 19/08. </strong>
					Inoltre ti informiamo che il nostro Servizio Cortesia mediante operatore telefonico o e-mail 
					<strong>non sarà disponibile dal 04/08 al 17/08 inclusi</strong>, ma potrai sempre rivolgerti al nostro 
					<strong>Assistente Virtuale</strong>, attivo 24 ore su 24.
				</div>
			</div>
		</div>`;

		document.querySelector('.main-cnt').insertAdjacentHTML('beforebegin', alertHtml);
		this.addCloseListener();
		window.scrollTo({top: 0, behavior: "smooth"});
	}

	addCloseListener() {
		const alertWrapper = document.querySelector('.alert-punti-estate-wrapper');
		alertWrapper.querySelector('.alert-close').addEventListener('click', () => {
			alertWrapper.remove();
			this.saveCookie();
		});
	}

	checkRangeDate() {
		const today = new Date().getTime();
		const upperLimit = new Date(2022, 7, 20, 0, 0, 0, 0).getTime(); // 19/08/22
		this.showMessage = today < upperLimit;
	}

	saveCookie() {
		const now = new Date();
		const expirationDate = new Date();
		expirationDate.setDate(now.getDate() + 1);
		Cookies.set('alertValidityDate', now, { expires: expirationDate } );
	}

	isAlertVisible() {
		const cookie = Cookies.get('alertValidityDate');
		return !cookie;
	}

	init() {
		this.checkRangeDate();
		if(!this.showMessage) return;
		if(!this.isAlertVisible()) return;
		this.appendAlert();
	}
}

export default AlertPuntiEstateComponent;